export const APP_VERSION = `V1.8.14 (${__APP_BUILD__})`;
export const APP_BUILD_DATE = new Date(parseInt(__APP_BUILD__, 36) * 1000).toUTCString();

export const CHANGELOG = [
  {
    version: 'V1.8.12',
    date: '11 juni 2026',
    changes: [
      'Android-loginfix: de Google-login keerde niet terug naar de app (strandde in de browser) — het /app-redirect-pad is hersteld als App Link en clando.app serveert nu een assetlinks-bestand zodat de terugkoppeling automatisch geverifieerd wordt.',
      'Statussen-automatisering werkt nu écht: statuswijzigingen vanuit Home Assistant of een agent voeren voortaan ook op de server de gekoppelde taakregels uit (draaide eerder alleen in de browser).',
      'Home Assistant-koppeling: automatiseringen kunnen nu een permanent Clando-token gebruiken in plaats van een sleutel die na een uur stilletjes verliep.',
      'Spraak begrijpt nu klusmeldingen: "Mark heeft een nieuwe blauwe zak opgehangen" wordt een afgevinkte taak op het scorebord in plaats van "niet herkend".',
      'Spraak leert slimmer: variaties op eerder gekoppelde zinnen worden herkend zonder AI-kosten, en elke regel in de spraakgeschiedenis toont voortaan hoe hij is verwerkt.',
      'Stabiliteit AI-functies: als een AI-model door de leverancier wordt uitgefaseerd schakelt de app automatisch over op een alternatief model, en een uurlijkse controle waarschuwt het team — geen wekenlang stille uitval meer.',
      'Koppel Claude: nieuwe wizard in Instellingen → Mijn apparaten genereert in drie stappen een persoonlijk token om Claude aan je Clando-team te koppelen.',
      'Foutregistratie vóór inloggen werkt nu (gestrande logins worden direct gemeld aan het team).',
    ],
  },
  {
    version: 'V1.8.11',
    date: '11 juni 2026',
    changes: [
      'TickTick-stijl: Refactored taak-rij weergave component (TickTickTaskRow) om code-duplicatie tussen lijst-, tijdlijn- en Kanban-weergaven op te lossen.',
    ],
  },
  {
    version: 'V1.8.10',
    date: '10 juni 2026',
    changes: [
      'Vertalingen: Ontbrekende Nederlandse vertalingen toegevoegd voor de nieuwe onboarding-keuzerondleiding om de i18n-validatie groen te maken.',
      'Taken Filteren: Bug opgelost waarbij voltooide taken in het planningsscherm bleven verschijnen met een doorstreping als completed filters uit stonden.',
      'TickTick Saved Filters: applyTaskFilter gecorrigeerd om voltooide taken correct uit te sluiten en de typesafe-afhandeling rond lastCompletedDate hersteld.',
    ],
  },
  {
    version: 'V1.8.9',
    date: '10 juni 2026',
    changes: [
      'Cozi-stijl Recepten: receptenbox en plan-vanavond flow brengt recepten rechtstreeks op het takenlijst-schema.',
      'Todoist-stijl Karma: productiviteitsstatistieken en streaks inzichtelijk gemaakt voor motivatie.',
      'TickTick-stijl Tijdlijn: chronologische weergave van alle taken met datums op één lijn.',
      'Automatische #tags in snel-toevoegen: een onbekende #tag wordt ter plekke aangemaakt en gekoppeld.',
      'Pomodoro Boek tijd: focus-minuten tellen mee in de statistieken en leaderboard.',
      'PWA self-heal: vastgepinde verouderde app-versies herstellen zichzelf na detectie van stale service worker.',
      '/vs vergelijkingspagina\'s tonen alle beschikbare interface-stijlen (Todoist, TickTick, Cozi, Bring!).',
      'Cross-spelling deduplicatie: Tomaat/Tomaten en soortgelijke termen herkend als dezelfde item in boodschappen en voorraad.',
      'Interval-herhalingen: geplande taken herhalen elk n maanden, weken of dagen (bijvoorbeeld "om de twee maandagen").',
    ],
  },

  {
    version: 'V1.8.8',
    date: '10 juni 2026',
    changes: [
      'Web-loginfix: een stille app-update (herlaad) kon precies tijdens de terugkeer van Google-login plaatsvinden en de inlogtokens opslokken — vooral op telefoons met een verouderde offline-versie. Updates worden nu uitgesteld zolang een login bezig is.',
      'Verouderde versies: de app controleert nu ook op updates wanneer je terugkeert naar het scherm (mobiele browsers pauzeren timers), zodat telefoons niet weken op een oude versie blijven hangen.',
    ],
  },

  {
    version: 'V1.8.7',
    date: '10 juni 2026',
    changes: [
      'Android-loginfix: de app claimde ALLE clando.app-links (App Links zonder pad), waardoor Google-login in de mobiele browser werd gekaapt op telefoons met de app geïnstalleerd. App Links zijn nu beperkt tot /share en /authorize-device. (Vereist deze native release om effect te hebben.)',
      'Release-fix: Android versionCode wordt nu afgeleid van de package-versie (1.8.7 → 10807) in plaats van hardcoded 1 — Play Store weigerde stilletjes elke upload na de eerste.',
      'Login-telemetrie: gebruikers die inloggen starten maar zonder sessie terugkeren worden voortaan stil gerapporteerd (gebruiker-geannuleerd vs. blokkerende fout vs. gestrand), zodat het team problemen ziet zonder meldingen van gebruikers.',
      'Interface-stijlen: nieuwe knop in de header opent een eigen kiezer met alle UI-stijlen, inclusief stijlen à la Bring!, TickTick, Todoist en Cozi (alles werkt op dezelfde data).',
      'TickTick-stijl compleet: Vandaag, Komende 7 dagen, Inbox, Kalender, Kanban, Filters, Eisenhower-matrix, Gewoontes, Pomodoro en #tags in snel-toevoegen.',
      'Cozi-stijl: boodschappenlijst en maaltijdplanner (gekoppeld aan de echte maaltijden-module) naast de gezinsweek.',
      'Bring!-stijl: bladerbare categoriecatalogus + zoeken, naast eerder gekochte items.',
      'Kern-UI: bewaarde filters ("smart lists") — sla je filtercombinatie op en roep hem met één tik terug.',
      'Kern-UI: Kanban-bord als vierde weergave naast lijst, planning en maandkalender.',
      'Kamers: de "Schoon"-knop registreert nu correct de laatste schoonmaakdatum (leek eerder niets te doen).',
      'Prestaties: tijdsduren worden afgerond (geen 25.733… meer) en de streak-weergave past nu op desktop.',
    ],
  },
  {
    version: 'V1.8.6',
    date: '9 mei 2026',
    changes: [
      'Productie-fix: backend-routes die in v1.8.5 alleen op Vercel werkten (`/api/...`) draaien nu via een runtime host-detectie. Op clando.app, Lovable-preview en native shells gaan calls naar Supabase Edge Functions; op `*.vercel.app` (Acceptance) blijven ze op `/api/...`.',
      'Cron-jobs: `check_task_notifications`, `check_motivation_reminders`, `check_stock_expiry_nudges` roepen voortaan rechtstreeks de Supabase Edge Functions aan (was: `https://clando.app/api/...`, dat 404\\\'de in productie).',
      'Nieuw helperbestand `src/lib/apiEndpoint.ts` (`apiUrl`/`apiFetch`) — voegt automatisch `apikey` + `Authorization` toe wanneer richting Supabase gefetched wordt.',
      'Nieuwe module Gezondheid (fase 1): beweging, gewicht en voeding bijhouden per teamlid; admin-toggle `show_health_module` per team.',
      'Experiments: server-side feature-flag overrides (per gebruiker/team/globaal) plus persistente gebruikerskeuze die team- en globale defaults overschrijft.',
      'Google Calendar: nieuwe sync-API en spraakcommando-afhandeling voor agenda-items.',
      'Disaster-recovery voorbereiding: nieuwe data-driver-laag (`src/data/*`) abstraheert tabel-I/O, zodat `*.vercel.app` deploys later naar een MSSQL-gateway kunnen routeren zonder UI-wijzigingen. Productie blijft op Supabase.',
      'Boodschappen: lage-voorraad waarschuwing samengevoegd tot één compacte knop in plaats van een rij badges, voorkomt UI-overlast.',
    ],
  },
  {
    version: 'V1.8.5',
    date: '9 mei 2026',
    changes: [
      'Toegankelijkheid: skip-to-content link — eerste Tab springt over shell-chrome (keyboard-first).',
      'Voorraad: SpendingPanel — maanden aan gekochte aankopen worden zichtbaar als inzicht.',
      'Maaltijden & push: verval-gestuurde herinnering in-app plus pre-diner push (pantry-moat buiten de app).',
      'Instellingen: taken importeren uit CSV/JSON-bestand met voorbeeld en validatie.',
      'Backend: device-auth, bot-account aanmaken, team-uitnodiging per e-mail, recept-URL-parser en send-push verplaatst van Supabase Edge Functions naar Vercel API-routes (`/api/…`), met gedeelde rate limiting en `web-push` op Node.',
      'Receptenbibliotheek: smallere typefouten en null-veiligheid in chips en bewerkingsmodal.',
      'Server-side MCP en enkele cron/edge-functies roepen send-push nog via de Supabase Edge URL aan; die paden kunnen later naar `/api/send-push` worden gezet.',
    ],
  },
  {
    version: 'V1.8.4',
    date: '9 mei 2026',
    changes: [
      "Productie-fix: 'Even geduld…' onderhoudsscherm verholpen — ontbrekende omgevingsvariabelen in de productiebuild zijn opgelost zodat de app weer normaal opstart.",
      "Monitoring: ontbrekende env-vars worden nu direct gerapporteerd via console én client-error-log, zodat een vergelijkbare release-incident onmiddellijk zichtbaar is voor agents.",
      "Tests: regressietest toegevoegd die vóór elke release controleert of .env aanwezig is, niet gegitignored is, en alle vereiste VITE_*-variabelen bevat.",
    ],
  },
  {
    version: 'V1.8.3',
    date: '9 mei 2026',
    changes: [
      "Synchronisatie: Vastlopend 'Synchroniseren...'-bandje opgelost — corrupte sync-effecten worden automatisch opgeschoond bij het openen van de app (max 5 pogingen of 24u).",
      "Synchronisatie: Permanente fouten (zoals rechten of validatie) worden niet meer eindeloos herhaald maar netjes geparkeerd in de dead-letter queue voor handmatige review.",
      "Boodschappen: Boodschappen verschijnen niet meer per ongeluk in de takenlijst, planning of agenda — strikte scheiding tussen taken en boodschappen.",
      "Stabiliteit: Build-fouten opgelost na schemawijziging (task_flows en device-autorisatie hersteld).",
    ],
  },
  {
    version: 'V1.8.2',
    date: '30 maart 2026',
    changes: [
      "Optimalisatie: Build-waarschuwingen voor dynamische imports opgelost voor betere prestaties.",
      "Bundel-optimalisatie: Chunking-strategie verfijnd om de initiële laadtijd te verkorten (vendor chunk verkleind van 1.8MB naar 234kB).",
      "Stabiliteit: HEIC-afbeeldingsbibliotheek wordt nu alleen geladen wanneer dat nodig is.",
    ],
  },
  {
    version: 'V1.8.1',
    date: '29 maart 2026',
    changes: [
      "Stabiliteit: Productie-build fout opgelost door het toevoegen van de ontbrekende @capacitor/app dependency.",
    ],
  },
  {
    version: 'V1.8.0',
    date: '28 maart 2026',
    changes: [
      "Webhooks: Ondersteuning voor 'silent login' via inloggegevens in de payload en directe JSON-antwoorden voor externe aanroepen.",
      "Vite: Server-side middleware toegevoegd voor slimme afhandeling van webhook-verzoeken.",
      "API: Productie-ready serverless function toegevoegd voor webhooks op Vercel.",
    ],
  },
  {
    version: 'V1.7.3',
    date: '14 maart 2026',
    changes: [
      "Algemene verbeteringen: Verschillende grootschalige verbeteringen en functionele updates.",
    ],
  },
  {
    version: 'V1.7.2',
    date: '14 maart 2026',
    changes: [
      "Synchronisatie: repository bijgewerkt naar de laatste versie op origin/main",
      "Datumbeheer: overstap naar lokale tijdformattering voor consistente weergave",
      "Sneller laden: taken worden direct getoond vanuit cache terwijl nieuwe data op de achtergrond wordt opgehaald",
      "Beveiliging: verbeterde webhook-validatie met invoerlengtebeperkingen",
      "Privacy: IP-adres tracking verwijderd voor betere GDPR-compliance",
      "Bot accounts: veiligere aanmaak via backend functie",
      "Stabiliteit: oneindige lus in profielupdates opgelost",
      "Motivatie-herinneringen: ondersteuning voor persoonlijke tijdzone en dagelijkse notificatie",
    ],
  },
  {
    version: 'V1.7.1',
    date: '21 februari 2026',
    changes: [
      "Klikbare statistieken: Bekijk voltooide taken door op de tellers van 'Vandaag' en 'Deze week' te klikken",
      "Onboarding: Verbeterde introductie voor het maken of lid worden van een (publiek) team",
      "Instellingen: Optie toegevoegd om een standaard team in te stellen bij het opstarten",
      "Leaderboard: Eerlijkere puntenverdeling met een minimum van 5 punten per taak",
      "Staatbeheer: Nieuwe 'Quick State Selector' voor snellere bediening op mobiel",
      "Slimme navigatie: Automatische redirects naar actieve modules bij het wisselen van teams",
      "Webhooks: Ondersteuning voor meerdere acties per webhook (aanmaken, bewerken, verwijderen)",
      "Vormgeving en Bugfixes: Consistente weergave van bijnamen, verbeterde taaktoewijzing en mobiele weergave",
    ],
  },
  {
    version: 'V1.7.0',
    date: '10 februari 2026',
    changes: [
      "Optimalisatie: snellere laadtijden door tekstcompressie en caching",
      "Bugfix: redirects bij inloggen en registreren opgelost",
      "Toegankelijkheid: betere ondersteuning voor schermlezers in dialogen",
      "Stabiliteit: diverse technische verbeteringen en bugfixes",
    ],
  },
  {
    version: 'V1.6.0.8',
    date: '8 februari 2026',
    changes: [
      "Process: gebruik van build-nummers voor ACC (1.6.0.x)",
      "Sync: versie in de footer is nu gekoppeld aan APP_VERSION",
    ],
  },
  {
    version: 'V1.6.0',
    date: '8 februari 2026',
    changes: [
      "Uitnodigingen: stuur gepersonaliseerde e-mails naar nieuwe teamleden",
      "Taalinstellingen: kies tussen Nederlands en Engels voor je team",
      "Edge Functions: nieuwe backend service voor betrouwbare e-mailverzending",
      "Design: prachtig opgemaakte HTML-uitnodigingen in de Clando stijl",
    ],
  },
  {
    version: 'V1.5.1',
    date: '8 februari 2026',
    changes: [
      "Process: automatische versie-synchronisatie via 'npm run version:*'",
      "Documentatie: commit-workflow toegevoegd voor AI-assistenten",
      "SemVer: duidelijk beleid voor Patch (bugs) en Minor (functies)",
    ],
  },
  {
    version: 'V1.5.0',
    date: '8 februari 2026',
    changes: [
      "Taak 'Pakken' (Grab): wijs snel taken aan jezelf toe met het hand-icoon",
      "Desktop UI: actieknoppen in een overzichtelijk 4-koloms rooster bij hover",
      "Layout stabiliteit: herstel van horizontale verschuiving in de header op laptops",
      "Staatbeheer: verbeterde popover stabiliteit bij het toewijzen van taken",
    ],
  },
  {
    version: 'V1.4.0',
    date: '1 februari 2026',
    changes: [
      "Nieuwe tag-categoriebeheer: per type icoon + subcategorieën met metadata",
      "Locatie-tags tonen vaste kleuren en iconen in taken en filters",
      "Filters vernieuwd: compacte knoppen en horizontale scroll op mobiel",
      "Kleurkiezer verbeterd met opslaan/annuleren en snelle acties",
    ],
  },
  {
    version: 'V1.3.1',
    date: '31 januari 2026',
    changes: [
      "Bugfix: snelle filter voor afgewerkte boodschappen werkt weer",
    ],
  },
  {
    version: 'V1.3.0',
    date: '31 januari 2026',
    changes: [
      "Webshop links: sla meerdere productlinks op bij voorraad en boodschappen",
      "Afbeeldingen in boodschappenlijst: zichtbare thumbnails met fullscreen viewer",
      "Automatische shopherkenning: AH, Bol.com, Amazon, etc. worden herkend",
    ],
  },
  {
    version: 'V1.2.0',
    date: '31 januari 2026',
    changes: [
      "Tijdregistratie: meet hoelang taken duren met live stopwatch",
      "Geschatte duur: admins kunnen inschatten hoelang een taak duurt",
      "Leaderboard: schakel tussen aantal taken en totale tijd",
      "Verbeterde tab navigatie: compacter design zonder zichtbare scrollbar",
    ],
  },
  {
    version: 'V1.1.1',
    date: '15 januari 2025',
    changes: [
      "Boodschappen tellen niet meer mee in het leaderboard",
    ],
  },
  {
    version: 'V1.1.0',
    date: '15 januari 2025',
    changes: [
      "Prullenbak: bekijk en herstel verwijderde taken",
      "Automatische opschoning: taken worden na 30 dagen definitief verwijderd",
      "Flows: groepeer taken in volgorde met voortgangsindicator",
      "Snooze functie voor terugkerende taken",
      "Verbeterde taak bewerking met uitgebreide opties",
      "Bugfix: soft-delete in plaats van directe verwijdering",
    ],
  },
  {
    version: 'V1.0.0',
    date: '21 december 2024',
    changes: [
      "Eerste release van de familie takenlijst app",
      "Dagelijkse, speciale en boodschappen taken",
      "Foto's toevoegen aan taken (camera & galerij)",
      "Locaties en toewijzingen",
      "Prioriteiten en deadlines",
      "TV-modus voor gezamenlijk overzicht",
      "Filters op persoon en categorie",
    ],
  },
];
